module.exports = __webpack_public_path__ + "media/images/search-3a72af9ef12c98746405bbf2069db4a7.svg";